jQuery(function($) {
    var vw = jQuery(window).width();
    if(vw >= 768 ) {
        jQuery(document).ready(function(){
            if(jQuery('.hb_field_home').length){
                jQuery('.hb_field_home .field-lists .posts-item').on('mouseover', function (e) {
                    jQuery(this).closest('.hb_field_home').find('.hover').removeClass('hover');
                    jQuery(this).addClass('hover');
                });
            }
        });
    }


});
